import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';

// Import your existing standalone components (adjust paths as needed)
import { CreateUserComponent } from './../../../../shared/user/components/create-user/create-user';
import { VerifyUserComponent } from './../../../../shared/user/components/verify-user/verify-user'; 
import { LoginComponent } from './../../../../shared/user/components/login/login'; 


@Component({
  selector: 'app-sales-auth-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, CreateUserComponent, VerifyUserComponent, LoginComponent],
  template: `
    <div class="auth-dialog-wrapper" style="max-height: 90vh; overflow-y: auto; overflow-x: hidden;">
        @if (currentView === 'create') {
            <app-create-user 
                [isDialogMode]="true" 
                (registerComplete)="onRegisterSuccess($event)">
            </app-create-user>
        }
        @if (currentView === 'verify') {
            <app-verify-user 
                [isDialogMode]="true" 
                [overrideEmail]="registeredEmail" 
                (verifyComplete)="onGoToLogin()" 
                (goToLogin)="onGoToLogin()"> </app-verify-user>
        }
        @if (currentView === 'login') {
            <app-login 
                [isDialogMode]="true" 
                (loginComplete)="onLoginSuccess()" 
                (goToSignup)="currentView = 'create'">
            </app-login>
        }
    </div>
  `
})
export class AuthDialogComponent implements OnInit {
  dialogRef = inject(MatDialogRef<AuthDialogComponent>);
  
  private readonly STORAGE_KEY = 'horizinns_auth_flow';
  
  currentView: 'create' | 'verify' | 'login' = 'create';
  registeredEmail: string | null = null;

  ngOnInit() {
    const savedState = localStorage.getItem(this.STORAGE_KEY);
    if (savedState) {
      try {
        const parsed = JSON.parse(savedState);
        this.currentView = parsed.step;
        this.registeredEmail = parsed.email;
      } catch (e) {
        // Fallback if JSON is corrupted
        this.resetFlow();
      }
    }
  }

  onRegisterSuccess(email: string) {
    this.registeredEmail = email;
    this.currentView = 'verify';
    
    // 2. Save state after creation
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify({
      step: 'verify',
      email: this.registeredEmail
    }));
  }

  onGoToLogin() {
    this.currentView = 'login';
    
    // 3. Save state when moving to login
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify({
      step: 'login',
      email: this.registeredEmail
    }));
  }

  onLoginSuccess() {
    // 4. IMPORTANT: Clear the state once they successfully finish the flow
    localStorage.removeItem(this.STORAGE_KEY);
    this.dialogRef.close(true);
  }

  resetFlow() {
    // Clears the state and returns them to the beginning
    localStorage.removeItem(this.STORAGE_KEY);
    this.currentView = 'create';
    this.registeredEmail = null;
  }
}